module.exports = __webpack_public_path__ + "img/camaras.7234424c.png";